// Estilos de categorías tipo Revolut/N26 — colores saturados sobre fondo dark
export const CATEGORY_STYLES = {
  FOOD:      { label: 'Food',      emoji: '🍔', bg: 'bg-orange-500',   ring: 'ring-orange-400/30',   text: 'text-orange-300' },
  'GO OUT':  { label: 'Go Out',    emoji: '🍸', bg: 'bg-pink-500',     ring: 'ring-pink-400/30',     text: 'text-pink-300' },
  BILLS:     { label: 'Bills',     emoji: '💡', bg: 'bg-yellow-500',   ring: 'ring-yellow-400/30',   text: 'text-yellow-300' },
  AMANDA:    { label: 'Amanda',    emoji: '💕', bg: 'bg-fuchsia-500',  ring: 'ring-fuchsia-400/30',  text: 'text-fuchsia-300' },
  MARTIN:    { label: 'Martin',    emoji: '💳', bg: 'bg-blue-500',     ring: 'ring-blue-400/30',     text: 'text-blue-300' },
  HOLIDAYS:  { label: 'Holidays',  emoji: '✈️', bg: 'bg-cyan-500',     ring: 'ring-cyan-400/30',     text: 'text-cyan-300' },
  HOUSE:     { label: 'House',     emoji: '🏠', bg: 'bg-emerald-500',  ring: 'ring-emerald-400/30',  text: 'text-emerald-300' },
  OTHERS:    { label: 'Others',    emoji: '📦', bg: 'bg-slate-500',    ring: 'ring-slate-400/30',    text: 'text-slate-300' },
};

export const getCategoryStyle = (cat) =>
  CATEGORY_STYLES[cat] || { label: cat || 'Other', emoji: '•', bg: 'bg-slate-500', ring: 'ring-slate-400/30', text: 'text-slate-300' };

export const CATEGORY_ORDER = ['FOOD', 'GO OUT', 'BILLS', 'AMANDA', 'MARTIN', 'HOLIDAYS', 'HOUSE', 'OTHERS'];

export const MONTH_NAMES_PT = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];
export const MONTH_NAMES_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
